<template>
	<div>
		<h2 style="text-align: center">Please Confirm Your Address</h2>
        <div v-for="(address, key) in renderedAddresses" v-bind:key="key" style="display: grid">
            <button @click="$emit('input', address.Id)" style="min-width: 250px;">
                <input type="radio"
                       :value="address.Id"
                       :checked="value === address.Id"
                       @change="$emit('input', $event.target.value)"
                       class="pull-left">
                <span style="text-align: left">
                    {{ address.Text }}
                    <br>
                    {{ address.Description }}
                </span>
            </button>
        </div>
	</div>
</template>

<script>
	export default {
		name: "address-valid-selector",
		props: {
			value : String,
			addresses: Array
		},
		data: function () {
			return {
			};
		},
		computed: {
		    renderedAddresses: function() {
		        return this.addresses.concat([{
		            Id: "NONE",
		            Text: "None of the above",
                    Description: ""
                }]);
            }
		},
		methods: {
		},
		mounted() {
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// address-valid-selector.vue?3e6015fa